import VisibleIf from '../../components/VisibleIf';
import { Link } from 'react-router';
import { getImageUrl } from '../../utils/cms-utils';
import { markdownToRawMarkup } from '../../utils/html-utils';
import { SectionTitle } from '../../components/typography/Heading';
import Image from '../../components/image/Image';
import styles from './cms-project-link.module.less';

const CMSProjectLink = ({ article }) => {
    const { headerImage, title, introduction } = article;
    const image = headerImage?.fields;
    const introductionAsHtml = markdownToRawMarkup(introduction);

    return (
        <div className={styles.linkCard}>
            <div className={styles.images}>
                {image && <Image src={getImageUrl(headerImage)} alt={image.description} />}
            </div>
            <SectionTitle className={styles.title}>{title}</SectionTitle>
            <div className={styles.introduction} dangerouslySetInnerHTML={introductionAsHtml} />
            <VisibleIf isVisible={!!article.projectId}>
                <Link to={`/project/${article.projectId}`} className={styles.link}>
                    {article.linkText || 'Sjekk spleisen'}
                </Link>
            </VisibleIf>
        </div>
    );
};

export default CMSProjectLink;
